import {coalesce} from '../../../utils/utils';
import {ModalName} from '../../../settings/settings';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const ESTIMATED_RATE_OF_RETURN = 'ESTIMATED_RATE_OF_RETURN';
export const AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL =
  'AUTO_RMD_TOOLD_AND_RESTRICTIONS_MODAL';
export const EXIT_MODAL = 'EXIT_MODAL';
export const RMD_CALCULATOR_DISCLAIMER = 'RMD_CALCULATOR_DISCLAIMER';
export const RMD_PRIOR_YEAR_UNAVAILABLE = 'RMD_PRIOR_YEAR_UNAVAILABLE';
export const CONFIRM_MODAL = 'CONFIRM_MODAL';
export const FAILURE_MODAL = 'FAILURE_MODAL';
export const SUCCESS_MODAL = 'SUCCESS_MODAL';
export const REINVEST_TO_NEW_CORE = 'REINVEST_TO_NEW_CORE';
export const DELETE_MODAL = 'DELETE_MODAL';
export const AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL =
  'AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL';
export const AS_OF_ACCOUNT_BALANCES = 'AS_OF_ACCOUNT_BALANCES';
export const AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS =
  'AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS';
export const AUTOMATIC_TRANSACTION_DELETE = 'AUTOMATIC_TRANSACTION_DELETE';
export const WITHHOLDING_DISCLOSURE_MODAL = 'WITHHOLDING_DISCLOSURE_MODAL';
export const STATES_DISCLOSURE_NOTES_MODAL = 'STATES_DISCLOSURE_NOTES_MODAL';
export const ESTIMATED_START_DATE_MODAL = 'ESTIMATED_START_DATE_MODAL';
export const SELECTED_DATE_MODAL = 'SELECTED_DATE_MODAL';
export const TAX_PAYER_MODAL = 'TAX_PAYER_MODAL';
export const QCD_HISTORY_MODAL = 'QCD_HISTORY_MODAL';
export const PAPERLESS_TERMS_MODAL = 'PAPERLESS_TERMS_MODAL';
const DEFAULT_STATE = {
  modalsSeen: {},
};

export default function openModals(state = DEFAULT_STATE, { type, payload }) {
  const { modalName } = payload || {}; // redux itself dispatches each type with null payload

  switch (type) {
    case OPEN_MODAL: {
      const { modalProps } = payload;
      return {
        ...state,
        [modalName]: coalesce(modalProps, {}),
        modalsSeen: {
          ...state.modalsSeen,
          [modalName]: true,
        },
      };
    }
    case CLOSE_MODAL: {
      const newState = { ...state };
      delete newState[modalName];
      return newState;
    }
    default: {
      return state;
    }
  }
}

export function openModal(modalName, modalProps) {
  try {
    // instantiate a CustomEvent with an eventType of “overlayLoad”
    const event = new CustomEvent('overlayLoad', {
      detail: {
        // set the value of the function’s overlay parameter to
        // a “overlay” property on the CustomEvent’s detail object
        overlay: ModalName[modalName],
      },
    });
    // dispatch the CustomEvent from the body
    document.body.dispatchEvent(event);
  } catch (e) {
    // handle exceptions as needed
  }
  return {
    type: OPEN_MODAL,
    payload: {
      modalName,
      modalProps,
    },
  };
}

export function closeModal(modalName) {
  return {
    type: CLOSE_MODAL,
    payload: {
      modalName,
    },
  };
}
